export enum SoapServiceUrl {
  Scontrini = 'https://eportale.eu/service-ejb/CorrispettivoElettronicoService?wsdl',
  Fatture = 'https://cloud.mysond.it/service-ejb/FatturaElettronicaService?wsdl',
}